
export class PartListConnectorModel {
    _id: string;
    connectorId: string;
    variantId: string;
    articleNumber: number;
    description: string;
    unit: string;
    qty: number;

    constructor(
        connectorId = '',
        articleNumber = null,
        description = '',
        unit = '',
        qty = null,
        variantId = ''
    ) {
            this.variantId = variantId;
            this.connectorId = connectorId;
            this.articleNumber = articleNumber;
            this.description = description;
            this.unit = unit;
            this.qty = qty;
    }
}
